function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useRef, useState } from 'react';
//@ts-ignore to do later
import { useIntersection } from "./intersectionObserver";
import { Image } from '@sitecore-jss/sitecore-jss-react';
//@ts-ignore to do later
import useBreakpoint from "../useBreakpoint";
//@ts-ignore to do later
//@ts-ignore to do later

var getFallbackSize = function getFallbackSize(sizes, name) {
  if (sizes['xl']) return sizes['xl'];
  if (sizes['lg']) return sizes['lg'];
  if (sizes['md']) return sizes['md'];
  if (sizes['sm']) return sizes['sm'];
};
var getSize = function getSize(sizes, name) {
  var _variant$value;
  var variant = sizes[name];
  if (variant && variant !== null && variant !== void 0 && (_variant$value = variant.value) !== null && _variant$value !== void 0 && _variant$value.src) {
    return variant;
  } else {
    if (!name) return;
    // wanted size is not available!
    return getFallbackSize(sizes, name);
  }
};

// const addMaxDimensionsToURL = (url: string) => {
//   if (url.indexOf('?') !== -1) {
//     return url + '&mw=1780&mh=980';
//   } else {
//     return url + '?mw=1780&mh=980';
//   }
// };

export var LazyLoadedImage = function LazyLoadedImage(props) {
  var _field$value;
  var src = props.src,
    alt = props.alt,
    className = props.className,
    isEditing = props.isEditing,
    field = props.field,
    phoneField = props.phoneField,
    loadDirectly = props.loadDirectly,
    defaultImage = props.defaultImage,
    animated = props.animated;
  var newClassName = className ? className : '';
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoaded = _useState2[0],
    setIsLoaded = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isInView = _useState4[0],
    setIsInView = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    hasError = _useState6[0],
    setHasError = _useState6[1];
  var imgRef = useRef(null);
  var breakpoint = useBreakpoint();
  var sizes = {
    xl: field,
    sm: phoneField
  };
  Object.keys(sizes).map(function (size) {
    var _val$value;
    var val = sizes[size];
    if (!val || !(val !== null && val !== void 0 && (_val$value = val.value) !== null && _val$value !== void 0 && _val$value.src)) {
      delete sizes[size];
    }
  });
  var variantField = getSize(sizes, breakpoint);

  // Not officially requested, but having a broken src will create a memory leak.
  var grayBg = 'data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==';
  var newDefaultImage = defaultImage ? defaultImage : grayBg;
  useIntersection(imgRef, function () {
    setIsInView(true);
  });
  useEffect(function () {
    if (!(imgRef !== null && imgRef !== void 0 && imgRef.current)) return;
    var imgRefCurrent = imgRef.current;
    imgRefCurrent.onload = function () {
      setIsLoaded(true);
    };
    imgRefCurrent.onerror = function () {
      setHasError(true);
    };
    return function () {
      if (!imgRefCurrent) return;
      imgRefCurrent.onload = null;
      imgRefCurrent.onerror = null;
    };
  }, [imgRef]);

  // if (isUsingNext()) {
  //   return <NextLazyLoadedImage {...props} />;
  // }

  if (isEditing) {
    return /*#__PURE__*/React.createElement(Image, {
      field: field,
      className: newClassName
    });
  }
  if (!src && !(field !== null && field !== void 0 && (_field$value = field.value) !== null && _field$value !== void 0 && _field$value.src) && !isEditing) {
    return null;
  }
  if (variantField) {
    var _variantField$value, _variantField$value2, _variantField$value3, _field$value2, _field$value3, _field$value4;
    if (!(variantField !== null && variantField !== void 0 && (_variantField$value = variantField.value) !== null && _variantField$value !== void 0 && _variantField$value.src)) return null;
    var fieldSrc = loadDirectly ? variantField === null || variantField === void 0 || (_variantField$value2 = variantField.value) === null || _variantField$value2 === void 0 ? void 0 : _variantField$value2.src : isInView ? variantField === null || variantField === void 0 || (_variantField$value3 = variantField.value) === null || _variantField$value3 === void 0 ? void 0 : _variantField$value3.src : undefined;
    return /*#__PURE__*/React.createElement("img", {
      alt: field === null || field === void 0 || (_field$value2 = field.value) === null || _field$value2 === void 0 ? void 0 : _field$value2.alt,
      className: "image ".concat(isLoaded ? 'image-loaded' : '', " ").concat(newClassName, " ").concat(loadDirectly ? 'image-loaded' : ''),
      ref: imgRef,
      height: field === null || field === void 0 || (_field$value3 = field.value) === null || _field$value3 === void 0 ? void 0 : _field$value3.height,
      width: field === null || field === void 0 || (_field$value4 = field.value) === null || _field$value4 === void 0 ? void 0 : _field$value4.width,
      src: !hasError ? fieldSrc : newDefaultImage,
      "data-scroll-zoom": animated
    });
  }
  var imgSrc = loadDirectly ? src : isInView ? src : undefined;
  return /*#__PURE__*/React.createElement("img", {
    alt: alt,
    className: "image ".concat(isLoaded ? 'image-loaded' : '', " ").concat(newClassName, " ").concat(loadDirectly ? 'image-loaded' : ''),
    ref: imgRef,
    src: !hasError ? imgSrc : newDefaultImage
  });
};